import { useContext } from 'react';
import { VideoContext } from '../contexts/VideoContext.js';

/**
 * Hook to access video call functionality and state.
 * Must be used within a VideoProvider component.
 *
 * @returns {VideoContextState} Video context state including room, connection status, and controls
 * @throws {Error} If used outside of VideoProvider
 *
 * @example
 * ```tsx
 * function VideoControls() {
 *   const { isConnected, toggleMic, toggleCamera, error } = useVideoCall();
 *
 *   if (error) {
 *     return <div>Error: {error.message}</div>;
 *   }
 *
 *   return (
 *     <div>
 *       <button onClick={toggleMic}>Toggle Mic</button>
 *       <button onClick={toggleCamera}>Toggle Camera</button>
 *     </div>
 *   );
 * }
 * ```
 */
export function useVideoCall() {
  const context = useContext(VideoContext);
  if (!context) {
    throw new Error('useVideoCall must be used within VideoProvider');
  }
  return context;
}